import React, { Component, useState, useEffect, useRef } from 'react';
import { Form, Modal, Button, Icon, Header, Input, Message } from 'semantic-ui-react'
import Amplify, { API } from 'aws-amplify';


let apiName = 'apirestcustomers2';
let path = '/customers';

let blankRecord = { "customer_id": 0,
                    "company_name": "",
                    "city": "", "country": ""}


function ModifyItem(value) {
    const [open, setOpen] = React.useState(false)
    const [errorMessage, setErrorMessage] = useState("") 
    const [result, setResult] = useState([])


    const [customer, setCustomer] =useState(blankRecord)

    function updating() {
        return (!value.id == 0)
    }

    useEffect(() => {
        if (open) {
            console.log("MODAL OPEN", value.id)
            if (updating()) {
                console.log("UPDATING")
                getCustomer(value.id)
            } else
            console.log("INSERTING")
                setCustomer(blankRecord)
        }
        else {
            setErrorMessage("")
        }
    }
    , [open])

    useEffect(() => {
        if ( Object.hasOwn(result, 'status')) {
            console.log("status", result.status)
        } else {
            setOpen(false)
        }
        }, [result])


    function handleChange(event, {name, value}) {
        setCustomer(prevState => {
            const newItem = Object.assign({}, customer)
            newItem[name] = value;
            //console.log("new ",newItem)
            return newItem;
        })
      }

    function handleSubmit() {
        console.log("handleSubmit", value)

        let editItem = {
            body: {
                values: {
                    "company_name": customer.company_name,
                    "city": customer.city,
                    "country": customer.country
                }
              }
            }

        if (updating()) {
            console.log("Performing update for", value)
            API.put(apiName, path + "/" + value.id, editItem).then(response => {
                console.log(response)
                setResult(response)
                value.setMessage({msgText: 'Record ' + response[0].customer_id + ' successfully updated', msgType: 'I'})
                }).catch(error => {
                    console.log("ERROR", error.response)
                    setErrorMessage(error.response.data.message)
                    setResult(error.response)
                    return;
                });
        }   else 
            API.post(apiName, path + "/" , editItem).then(response => {
                console.log(response)
                setResult(response)
                setErrorMessage("")
                value.setMessage({msgText: 'Record successfully created with ID ' + response[0].customer_id, msgType: 'I'})
                }).catch(error => {
                    console.log("ERROR", error.response)
                    setErrorMessage(error.response.data.message)
                    setResult(error.response)
                    return;
                });
        }


    function getCustomer(id) {
        console.log("Entering getCustomer")
        let queryStringParams = {
            queryStringParameters: {
                limit: 1,
                offset: 0
            }
        }
        API.get(apiName, path + "/" + id
            , queryStringParams)
            .then(response => {
                console.log("getCustomer response is",response)
                setCustomer(response[0])
            })
            .catch(error => {
                console.log( error)
                if (error.response.data.statusCode = 404) {
                    setCustomer(blankRecord)
                    setErrorMessage('Record was not found.')   
                }
             
            })

    }

    return ( 
        <Modal
          as={Form}
          onSubmit={e => handleSubmit(e)}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          open={open}
          trigger={<Button size='small'>
                    <Icon name={updating() ? "edit" : "add"}/>
                    {updating() ? value.id : "Create"}
          </Button>}
        >
          <Header><Icon name={updating() ? "edit" : "add"} color='blue' />{updating() ? "Edit" : "Create new"} Customer {updating() ? value.id : ""}</Header>
          <Modal.Content>
              <p><Input value={customer.company_name} name="company_name" label="Name" onChange={handleChange}></Input></p>
              <p><Input value={customer.city} name="city" label="City" onChange={handleChange}></Input>
                  <Input value={customer.country} name="country" label="Country" onChange={handleChange} maxLength="15"></Input></p>
         
                  <Message  error visible={errorMessage.length>0} >
                      <Icon name='exclamation mark' />{errorMessage}
                  </Message>
          </Modal.Content>
          
          <Modal.Actions>
            <Button type='button' color='black' onClick={(event) => {
                                                          //TODO: Revert to old values                               
                                                          //console.log("prev", prevState)
                                                          //setCustomers(prevState)
                                                          setOpen(false)
                                                          }}>
              Cancel
            </Button>
            <Button
              content='Save'
              type='submit'
              labelPosition='right'
              icon='checkmark'            
              positive
            />
           
          </Modal.Actions>
          
        </Modal>
        
      )
  

}

export default ModifyItem